var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('headerTop'),_c('div',{staticClass:"body-box"},[_c('router-view')],1),_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }